import { useEffect } from 'react';

/**
 * Injects <meta name="robots" content="noindex, nofollow"> into the document
 * head while this component is mounted, and removes it on unmount.
 *
 * Used on the legal boilerplate pages (privacy / terms) that name the sole
 * trader — we don't want those surfacing in search results for a name query.
 * Googlebot renders the SPA and honours JS-injected robots meta tags, so this
 * reliably drops the page from the index once it's re-crawled.
 *
 * NOTE: do NOT also `Disallow` these paths in robots.txt — a disallow stops
 * Googlebot from crawling the page at all, so it never sees this tag and the
 * URL can linger in the index without a snippet. noindex must stay crawlable.
 */
export default function NoIndex() {
  useEffect(() => {
    const tag = document.createElement('meta');
    tag.name = 'robots';
    tag.content = 'noindex, nofollow';
    document.head.appendChild(tag);
    return () => {
      document.head.removeChild(tag);
    };
  }, []);

  return null;
}
